<template>
  <div class="viewer wrap-content">
    <iframe id="viewerIframe" name="viewerIframe" :src="'/static/pdfView/web/viewer.html?' + this.src" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  name: 'viewer',
  props: {
    url: ''
  },
  data () {
    return {
      src: '',
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      curPageNum: 0
    }
  },
  created () {
    if (this.url) {
      this.src = this.url;
    } else {
      this.src = this.$route.query.url
    }
  },
  mounted () {
  },
  watch: {
    url: {
      handler (val) {
        this.src = this.url;
        this.$nextTick(function () {
          document.frames('viewerIframe').location.reload();
        });
      }
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
  .viewer {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/layout/customPage/thesisManage/viewer.vue